<template lang="pug">
.cell-content-wrapper
  .cell-content(:title="data") {{ data }}
</template>

<script>
export default {
    name: 'CellContent',
    props: {
        data: { type: [String, Number], default: '' },
        type: { type: String, default: '' },
        fullData: { type: Object, default: () => ({}) },
        parentId: { type: [String, Number], default: null }
    }
}
</script>
